// Import CSS style
import myStyle from "./material.module.css";

// Import react-spring for animations
import { useSpring, animated } from "@react-spring/web";

import consoleData from "../../assets/materialsDB/CONSOLE.json";
import eurotrussData from "../../assets/materialsDB/EUROTRUSS.json";
import ProiettoriTeatraliData from "../../assets/materialsDB/proiettoriTeatrali.json";
import proiettoriTestemobiliData from "../../assets/materialsDB/testeMobili.json";
import proiettoriBatteriaData from "../../assets/materialsDB/proiettoriBatteria.json";
import proiettoriArchitetturaliData from "../../assets/materialsDB/proiettoriArchitetturali.json";
import quadriCablaggioData from "../../assets/materialsDB/CABLAGGIO.json";
import accessoriData from "../../assets/materialsDB/ACCESSORI.json";

import Category from "../../components/category/Category";
import { Box } from "@chakra-ui/react";
import { Helmet } from "react-helmet-async";

const Console = () => {
  return (
    <Category
      isEven={true}
      title="Console"
      data={consoleData}
      subcategory={["Mixer luci", "Splitter", "Tx/rx wi-fi", "Dimmer"]}
    />
  );
};

// };
const ProiettoriTeatrali = () => {
  return (
    <Category
      title="Proiettori teatrali"
      data={ProiettoriTeatraliData}
      subcategory={[
        "Super lucciola 8°/24°",
        "Qps hmi modificato",
        "Qps",
        "Eclipse hdtwc rgb",
        "Etc",
        "Sagoled",
        "Zoom",
        "Zoom nano",
        "Seguipersona",
        "Led 100",
        "Minifresnel",
        "Minifresnel scarica",
        "Performer",
        "Quarzina",
        "Quarzina led",
        "Hmi",
      ]}
    />
  );
};

const TesteMobili = () => {
  return (
    <Category
      isEven={true}
      title="Teste mobili"
      data={proiettoriTestemobiliData}
      subcategory={[
        "Archer s7",
        "Iw-1941 rdm",
        "Phantom 3r hybrid",
        "Giotto spot cmy",
        "Giotto wash cmy",
        "Synthesis",
        "Infinity iw 19-15",
        "Idea moving led",
        "Air5fan",
        "Beam xr2000",
      ]}
    />
  );
};
const ProiettoriArchitetturali = () => {
  return (
    <Category
      title="Proiettori architetturali"
      data={proiettoriArchitetturaliData}
      subcategory={["Q7", "Palco 5 led", "Cameleon bar led", "Par led zoom"]}
    />
  );
};

const Eurotruss = () => {
  return (
    <Category
      isEven={true}
      title="Eurotruss"
      data={eurotrussData}
      subcategory={[
        "Lineari",
        "Angoli",
        "Curva",
        "Accessori",
        "Eurotruss nera lineari",
        "Eurotruss nera angoli",
      ]}
    />
  );
};

const ProiettoriBatteria = () => {
  // TODO: DA TOGLIERE SPLITTARE IN TEATRALI E A BATTERIA .json
  return (
    <Category
      isEven={true}
      title="Proiettori a batteria"
      data={proiettoriBatteriaData}
      subcategory={[
        "Aurora",
        "Titan",
        "X9",
        "Smartbat Nero",
        "Smartbat Bianco",
        "Tabled",
      ]}
    />
  );
};

const QuadriCablaggio = () => {
  return (
    <Category
      title="Quadri & cablaggio"
      data={quadriCablaggioData}
      subcategory={["Cablaggio", "Sp/pr", "Temporizzato"]}
    />
  );
};

const Accessori = () => {
  return (
    <Category
      title="Accessori"
      data={accessoriData}
      subcategory={[
        "Supporti",
        "Ottica etc",
        "Ottica sagoled",
        "Tg",
        "Bandiere",
        "Elevatori",
        "Dispositivi di sicurezza",
        "Fascie",
        "Audio & Video",
      ]}
    />
  );
};

const Material = (data) => {
  const spring = useSpring({
    from: { x: -1000 },
    to: { x: 0 },
  });

  return (
    <Box as="section" className={myStyle.material}>
      <Helmet>
        <title>Controluce Illuminazione di Monti Daniele - Materiali</title>
        <meta
          name="description"
          content="Ecco un elenco dettagliato dei materiali di Controluce Illuminazione, sempre aggiornati e al passo con le tecnologie odierne. Tra cui eurotruss, proiettori parabolici, sagomatori, a batteria e tanto altro !"
        />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "ItemList",
            name: "Catalogo Materiali Illuminotecnici",
            description: "Prodotti professionali per service luci ed eventi",
            url: "https://www.controluceilluminazione.it/material",
            numberOfItems: 6,
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                item: {
                  "@type": "ProductGroup",
                  name: "Proiettori Teatrali",
                  description:
                    "Proiettori professionali per scenografie teatrali ed eventi",
                  category: "Illuminotecnica",
                  hasVariant: {
                    "@type": "Product",
                    name: "Proiettore Teatrale",
                    offers: {
                      "@type": "Offer",
                      priceSpecification: {
                        "@type": "UnitPriceSpecification",
                        description:
                          "Contatta il nostro service luci per un preventivo gratuito e senza impegno.",
                      },
                      availability: "https://schema.org/InStock",
                      businessFunction:
                        "http://purl.org/goodrelations/v1#ProvideService",
                      url: "https://www.controluceilluminazione.it/contact",
                    },
                  },
                  hasOfferCatalog: {
                    "@type": "OfferCatalog",
                    name: "Service luci - Proiettori teatrali",
                    url: "https://www.controluceilluminazione.it/material",
                  },
                },
              },
              {
                "@type": "ListItem",
                position: 2,
                item: {
                  "@type": "ProductGroup",
                  name: "Proiettori a batteria",
                  description:
                    "L'Illuminazione autonoma del nostro service luci senza alimentazione esterna.",
                  category: "Illuminazione mobile",
                  hasVariant: {
                    "@type": "Product",
                    name: "Proiettore a batteria",
                    offers: {
                      "@type": "Offer",
                      priceSpecification: {
                        "@type": "UnitPriceSpecification",
                        description:
                          "Contatta Controluce illuminazione per un preventivo gratuito e senza impegno - Service luci",
                      },
                      availability: "https://schema.org/InStock",
                      businessFunction:
                        "http://purl.org/goodrelations/v1#ProvideService",
                      url: "https://www.controluceilluminazione.it/contact",
                    },
                  },
                  hasOfferCatalog: {
                    "@type": "OfferCatalog",
                    name: "Service Luci - Proiettori",
                    url: "https://www.controluceilluminazione.it/material",
                  },
                },
              },
              {
                "@type": "ListItem",
                position: 3,
                item: {
                  "@type": "ProductGroup",
                  name: "Eurotruss",
                  description:
                    "I migliori eurotruss utilizzati nell'allestimento scenico delle arti performative del nostro service luci.",
                  category: "Supporto allestimento",
                  hasVariant: {
                    "@type": "Product",
                    name: "Eurotruss",
                    offers: {
                      "@type": "Offer",
                      priceSpecification: {
                        "@type": "UnitPriceSpecification",
                        description:
                          "Contatta il nostro service luci per un preventivo gratuito e senza impegno - Controluce illuminazione",
                      },
                      availability: "https://schema.org/InStock",
                      businessFunction:
                        "http://purl.org/goodrelations/v1#ProvideService",
                      url: "https://www.controluceilluminazione.it/contact",
                    },
                  },
                  hasOfferCatalog: {
                    "@type": "OfferCatalog",
                    name: "Service Luci - Eurotruss",
                    url: "https://www.controluceilluminazione.it/material",
                  },
                },
              },
              {
                "@type": "ListItem",
                position: 4,
                item: {
                  "@type": "ProductGroup",
                  name: "Quadri e cablaggio",
                  description:
                    "I nostri migliori quadri e il cablaggio per un servizio illuminotecnico completo.",
                  category: "Illuminazione mobile",
                  hasVariant: {
                    "@type": "Product",
                    name: "Quadri e cablaggio",
                    offers: {
                      "@type": "Offer",
                      priceSpecification: {
                        "@type": "UnitPriceSpecification",
                        description:
                          "Contatta Controluce illuminazione, service luci, per un preventivo gratuito e senza impegno.",
                      },
                      availability: "https://schema.org/InStock",
                      businessFunction:
                        "http://purl.org/goodrelations/v1#ProvideService",
                      url: "https://www.controluceilluminazione.it/contact",
                    },
                  },
                  hasOfferCatalog: {
                    "@type": "OfferCatalog",
                    name: "Service Luci - Quadri e cablaggio",
                    url: "https://www.controluceilluminazione.it/material",
                  },
                },
              },
              {
                "@type": "ListItem",
                position: 5,
                item: {
                  "@type": "ProductGroup",
                  name: "Console",
                  description: "Le console del nostro service luci.",
                  category: "Illuminazione mobile",
                  hasVariant: {
                    "@type": "Product",
                    name: "Console",
                    offers: {
                      "@type": "Offer",
                      priceSpecification: {
                        "@type": "UnitPriceSpecification",
                        description:
                          "Contattaci per un preventivo gratuito e senza impegno - Controluce illuminazione - Service luci",
                      },
                      availability: "https://schema.org/InStock",
                      businessFunction:
                        "http://purl.org/goodrelations/v1#ProvideService",
                      url: "https://www.controluceilluminazione.it/contact",
                    },
                  },
                  hasOfferCatalog: {
                    "@type": "OfferCatalog",
                    name: "Service Luci - Console",
                    url: "https://www.controluceilluminazione.it/material",
                  },
                },
              },
              {
                "@type": "ListItem",
                position: 6,
                item: {
                  "@type": "ProductGroup",
                  name: "Accessori",
                  description:
                    "Tutti i nostri accessori per un service luci completo.",
                  category: "Illuminazione mobile",
                  hasVariant: {
                    "@type": "Product",
                    name: "Accessori",
                    offers: {
                      "@type": "Offer",
                      priceSpecification: {
                        "@type": "UnitPriceSpecification",
                        description:
                          "Contatta Controluce illuminazione, il service luci, per un preventivo gratuito e senza impegno.",
                      },
                      availability: "https://schema.org/InStock",
                      businessFunction:
                        "http://purl.org/goodrelations/v1#ProvideService",
                      url: "https://www.controluceilluminazione.it/contact",
                    },
                  },
                  hasOfferCatalog: {
                    "@type": "OfferCatalog",
                    name: "Service Luci - Accessori",
                    url: "https://www.controluceilluminazione.it/material",
                  },
                },
              },
            ],
          })}
        </script>
      </Helmet>

      <TesteMobili />
      <ProiettoriTeatrali />
      <ProiettoriBatteria />
      <ProiettoriArchitetturali />
      <Eurotruss />
      <QuadriCablaggio />
      <Console />
      <Accessori />
    </Box>
  );
};

export default Material;
